import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
import mediaQueries from 'syf-component-library/const/mediaQueries';
import { spacing } from 'syf-component-library/defaultTheme';
import { Grid } from 'syf-component-library/ui/patterns';
import { Inset } from 'syf-component-library/ui/spacing';
import { t } from '../../../../strings/i18n';
import { CreditBalanceProgressBar } from '../../../../ui/atoms/CreditBalanceProgressBar';
import IntroHeading from '../../../../ui/atoms/IntroHeading';
export const ConfirmationImage = styled('img') `
  max-width: 100%;
  max-height: 100%;
`;
const OneTimePaymentSubtitle = styled(Inset) `
  padding: 0 ${spacing.large}px ${spacing.large}px ${spacing.large}px;

  @media ${mediaQueries.lessThanSmall} {
    padding-inline: 0px;
  }
`;
const ImageWrapper = styled(Grid) `
  flex-direction: column;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
`;
const getSectionHeading = (isEnrolledInOneClickAutopay, hasOneClickAutopayError, isPaymentPending) => {
    if (isPaymentPending) {
        return t('oneTimePayment.pendingPaymentHeading');
    }
    if (isEnrolledInOneClickAutopay && !hasOneClickAutopayError) {
        return t('text.oneTimeAndAutopayConfirmed');
    }
    return t('text.thanksForPaymentSub');
};
const OneTimeConfirmationHeading = ({ shouldHaveEnrolledInOneClickAutopay, hasOneClickAutopayError, isPaymentPending }) => (_jsx(Inset, Object.assign({ bottom: "large", top: "xlarge" }, { children: _jsx(ImageWrapper, { children: _jsx(IntroHeading, Object.assign({ weight: "bold" }, { children: getSectionHeading(shouldHaveEnrolledInOneClickAutopay, hasOneClickAutopayError, isPaymentPending) })) }) })));
const OneTimePaymentConfirmationHeader = ({ autopayConfirmationBannerURL, availableCredit, creditLimit, hasOneClickAutopayError, initialAvailableCredit, isPaymentPending, paymentAmount, shouldDisplayAvailableCredit, shouldHaveEnrolledInOneClickAutopay, staticHostName }) => {
    return (_jsxs(ImageWrapper, Object.assign({ container: true }, { children: [_jsx(ConfirmationImage, { alt: "", "aria-hidden": "true", src: `${staticHostName}${autopayConfirmationBannerURL}` }), _jsx(OneTimeConfirmationHeading, { hasOneClickAutopayError: hasOneClickAutopayError, isPaymentPending: isPaymentPending, shouldHaveEnrolledInOneClickAutopay: shouldHaveEnrolledInOneClickAutopay }), shouldDisplayAvailableCredit && (_jsxs(_Fragment, { children: [_jsx(CreditBalanceProgressBar, { creditLimit: creditLimit, creditLimitText: t('oneTimePayment.totalCreditLine'), initialAvailableCredit: Math.max(0, initialAvailableCredit), paymentAmount: paymentAmount, tooltipContent: t('oneTimePayment.availableCreditTooltip'), topTitle: t('label.availableCredit'), updatedAvailableCredit: availableCredit }), _jsx(Inset, { bottom: "large" })] })), !isPaymentPending && (_jsx(OneTimePaymentSubtitle, Object.assign({ "data-cy": "payment-confirmation-secondary-heading" }, { children: t('oneTimePayment.daysAvailableAfterPaymentMessage') })))] })));
};
export default OneTimePaymentConfirmationHeader;
